module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/stopper-desktop-bg-434f4f049e1b2efe55f95b1927d78699.webp";